import { gql } from '@apollo/client';

import { documentFragment } from '../fragments';

export default gql`
  mutation ToggleDocument(
    $courseId: String!
    $subjectId: String!
    $documentId: String!
    $status: String!
  ) {
    document(
      courseId: $courseId
      subjectId: $subjectId
      documentId: $documentId
      status: $status
      input: {}
    )
      @rest(
        type: "Document"
        path: "courses/{args.courseId}/subjects/{args.subjectId}/documents/{args.documentId}/{args.status}"
        method: "PUT"
      ) {
      ...Document
    }
  }
  ${documentFragment}
`;
